import { StoreInterfaceType } from '@clientos/types';
import StoreInterfaceV1 from './StoreInterfaceV1';

export { createNoopStoreInterface } from './NoopInterface';

let storeInterfaceV1: StoreInterfaceV1;

export function getStoreInterfaceV1(): StoreInterfaceType {
  return storeInterfaceV1.getInterface();
}

export default async function initializeStoreInterfaceV1(): Promise<StoreInterfaceType> {
  if (storeInterfaceV1) return storeInterfaceV1.getInterface();
  storeInterfaceV1 = new StoreInterfaceV1();

  return storeInterfaceV1.getInterface();
}
